import { cloneDeep } from "lodash-es";

const SPORTS = {
  basketball: {},
  handball: {
    redCardSeconds: {
      client: (seconds) => seconds / 60,
      server: (minutes) => minutes * 60,
    },
    yellowCardSeconds: {
      client: (seconds) => seconds / 60,
      server: (minutes) => minutes * 60,
    },
    blueCardSeconds: {
      client: (seconds) => seconds / 60,
      server: (minutes) => minutes * 60,
    },
  },
  hockey: {
    greenCardSeconds: {
      client: (seconds) => seconds / 60,
      server: (minutes) => minutes * 60,
    },
    yellowCardSeconds: {
      client: (seconds) => seconds / 60,
      server: (minutes) => minutes * 60,
    },
    warmupSeconds: {
      client: (seconds) => seconds / 60,
      server: (minutes) => minutes * 60,
    },
    shootoutSecondsCountdown: {
      client: (seconds) => seconds / 60,
      server: (minutes) => minutes * 60,
    },
  },
  ice3: {},
};

const convertFields = ({ data, type, sport }) => {
  const copyData = cloneDeep(data);

  Object.keys(SPORTS?.[sport])?.forEach((fieldName) => {
    if (copyData?.[fieldName]) {
      copyData[fieldName] = SPORTS?.[sport]?.[fieldName]?.[type](copyData?.[fieldName]);
    }
  });

  return copyData;
};

export default convertFields;
